<template>
 <main class="views" role="main">
  <div v-if="resource">
      <!-- Successful resource share modal -->
      <b-modal id="modal-1" title="Success" ok-only>
        <p class="my-2">
          This ingredient is shared with the user you have chosen!
        </p>
      </b-modal>
      <b-modal id="modal-2" title="Success" ok-only>
        <p class="my-2">
          This ingredient is shared with the group you have chosen!
        </p>
      </b-modal>
      <!-- Share Resource  Modal -->
      <b-modal
        size="lg"
        id="modal-prevent-closing"
        ref="modal"
        v-bind:title="'Share this ingredient ' + this.title"
        ok-variant="danger"
        ok-title="Share"
        @cancel="hideModal"
        @ok="handleOk"
      >
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <div class="container">
            <b-form-group
              label="Do you wish to share this resource with a single user or a group?"
            >
              <!--              <b-form-radio-group id="radio-group-2" v-model="selected" @input="showConsole" name="radio-sub-component">-->
              <b-form-radio-group
                id="radio-group-2"
                v-model="selected"
                name="radio-sub-component"
              >
                <b-form-radio value="a">a single user</b-form-radio>
                <b-form-radio value="b">a group</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group v-if="this.selected === 'a'">
              <p class="my-2">Whom would you like to share this with?</p>

              <Autocomplete :EventBus="sendChosenLogin1"></Autocomplete>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyLoginAlert"
                variant="danger"
              >
                This UserName is invalid!
              </b-alert>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="notFoundUserAlert"
                variant="danger"
              >
                An error occurred! Maybe the UserName you submitted does not
                exist!
              </b-alert>
            </b-form-group>

            <b-form-group
              v-if="this.selected === 'b'"
              label="Which group would you like to share this resource with?"
              label-align="left"
            >
              <b-form-input
                style="width: 100%"
                v-model="GroupChosen"
                placeholder="Enter the Group name"
              >
              </b-form-input>

              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyGroupNameAlert"
                variant="danger"
              >
                This group name is invalid!
              </b-alert>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="notFoundGroupAlert"
                variant="danger"
              >
                An error occured! Maybe the group you submitted does not exist!
              </b-alert>
            </b-form-group>
          </div>

          <hr />

          <b-form-group
            class="col-12"
            label="What right will you grant to this user?"
            label-align="left"
          >
            <b-form-select :options="Rights" v-model="right"> </b-form-select>
            <b-alert
              dismissible
              style="width: 100%"
              v-model="emptyRightAlert"
              variant="danger"
            >
              You have to specify the right!
            </b-alert>
          </b-form-group>
        </form>
      </b-modal>

        <!-- sub header-->
      <section class="subheader">
        <div class="container-fluid px-6"> 
          <!-- left-->
          <div class="title ingredient">
            <div class="centered d-flex align-items-center">
              <div class="wraps"><span>Ingredient</span>
                <h2 style="overflow-wrap: break-word">{{
                  resource.title
                }} <span class="mx-3" v-if="authenticatedUser && this.$store.state.user.login !== this.resource.creator.login"><b-link
                     :title="!resource.bookmarked ? 'Add bookmark' : 'Remove Bookmark'"
                    v-b-tooltip.hover.top
                    @click="handleBookmarkResource(resource)"
                  >
                      <i
                        style="color: red"
                        :class="resource.bookmarked ? 'fas fa-bookmark fa-sm' : 'far fa-bookmark fa-sm'"
                      ></i>
                  </b-link></span>
          <!-- action--></h2>
              </div>
            </div>
          </div>
          
          <ul class="action"> 
            <li  v-show="isShareable"> <a href="#" @click="ShareThisResource"><i class="fas fa-share-alt"></i>&nbsp; Share</a></li>
            </ul>
          <ul class="action modify">
            <li> <router-link
                    :to="{
                      name: 'resourceEdit',
                      params: { id: this.$route.params.id },
                    }"
                    title="Edit the ingredient"
                    v-b-tooltip.hover.top
                    v-show="isEditable"
                  >Edit</router-link></li>
            <li> <b-link v-if="isDeletable"
                    @click.prevent="showMsgDelete(resource.id, resource.title)"
                    class="red"
                    title="Delete the ingredient"
                    v-b-tooltip.hover.top
                   
                  >Delete</b-link></li>
          </ul>
        </div>
        
      </section>

       <div class="container-fluid px-6">
         <div class="row viewsdetail">
          <div class="col-lg-8 left">
            <div class="metadata">
              <div class="produced" v-if="resource.madeInProject">Produced by <b>CultureLabs</b></div>
              <div class="meta-item row">
                <div class="col-lg-3 title">Ingredient Creation </div>
                <div class="col-lg-9 data">By <span class="username">{{ resource.creator.login }}</span> on {{ resource.created | utcLocalDatetime }}</div>
              </div>
              <div class="meta-item row">
                <div class="col-lg-3 title">Average Rating</div>
                <div class="col-lg-9 data">{{ averageRatingStars }}/5
                  <ul class="stars">
                   <v-app>
                      <v-rating
                      v-model="averageRating"
                      background-color="orange lighten-3"
                      color="orange"
                      medium
                      readonly
                      hover
                      half-increments
                    ></v-rating>
                  </v-app>
                  </ul>
                </div>
              </div>
              <div class="meta-item row" v-if="resource.contentLanguage && resource.contentLanguage.length>0">
                <div class="col-lg-3 title">Language</div>
                <div class="col-lg-9 data"> {{ getResourceLanguage() }}</div>
              </div>
              <div class="meta-item row" v-if="resource.resourceType && resource.resourceType.length > 0">
                <div class="col-lg-3 title">Ingredient Type</div>
                <div class="col-lg-9 data">{{ getResourceType() }}</div>
              </div>
              <div class="meta-item row" v-if="resource.license && resource.license.length >0">
                <div class="col-lg-3 title">License</div>
                <div class="col-lg-9 data">{{ getResourceLicense() }}</div>
              </div>
               <div class="meta-item row" v-if="resource.mediaType">
                <div class="col-lg-3 title">Media Type</div>
                <div class="col-lg-9 data">{{ resource.mediaType }}</div>
              </div>
              <div class="meta-item row">
                <div class="col-lg-3 title">Visibility</div>
                <div class="col-lg-9 data">{{ visibility }}</div>
              </div>
              <div class="meta-item row" v-if="resource.keywords && resource.keywords.length>0">
                <div class="col-lg-3 title">Tags</div>
                <div class="col-lg-9 data">
                 <Keywords
                  type="ingredient"
                  id="keywords-list"
                  v-bind:keywords="resource.keywords"
                ></Keywords>
                </div>
              </div>
            </div>
            <div class="description mb-4"> 
              <div class="heading">
                <h2>Description </h2>
              </div>
              <div class="content">
                <p style="white-space: pre-line;overflow-wrap: break-word;">{{ resource.description }}</p>
              </div>
            </div>
           <!-- end description -->
          
           <div class="rating" v-if="ratings.length>0">
              <div class="heading">
                <h2>Ratings</h2>
              </div>
              <div class="content">
                <div class="row raters" v-for="(rating, index) in ratings" :key="index">
                  <Rating :rating="rating" :ratingIndex="index" :lastRatingIndex="ratings.length" ></Rating>
                </div>
               
              <div class="paging d-flex justify-content-center" v-if="showPagination">
                <b-pagination
                v-model="pagination.currentPage"
              :total-rows="pagination.totalCount"
              :per-page="pagination.pageSize"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              align="center"
              @input="getRatings"
              >
              </b-pagination>
              </div>
            </div>
          </div>
        
      </div>


       <!-- col right-->
       <div class="col-lg-4">
            <!-- sidebar-->
            <div class="sidebar">
              <div class="thumbnail ingredient">
                  <div class="mediatype">
                    <img v-if="resource.mediaType === 'Image' && !resource.url" src="/static/img/ic-media-picture.png">
                    <img v-else-if="resource.mediaType === 'Text' || resource.mediaType === 'Other'" src="/static/img/ic-media-document.png">
                    <img v-else-if="resource.mediaType === 'Website'" src="/static/img/ic-media-link.png">
                    <img v-else-if="resource.mediaType === 'Audio'" src="/static/img/ic-media-audio.png">
                      <img v-else-if="resource.mediaType === 'Linked Video'" src="/static/img/ic-media-video.png">
                    <img v-else src="/static/img/ic-media-document.png">
                    <a :href="getResourceLink()"><i class="fas fa-external-link-alt"></i> View content</a>
                  </div><b-img
                  v-if="resource.url && resource.mediaType === 'Image'"
                  :src="resource.url"
                  class="mb-2"
                  fluid-grow
                ></b-img>
              </div>
              <!-- accordion-->
              <div class="data-accordion accordion accordion-flush">
               <div class="accordion-item" v-if="resource.creatorsWithId || resource.creators.length>0">
                  <h2 class="accordion-header" id="flush-headingTwo">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" :data-bs-target="'#flush-collapseTwo'" aria-expanded="false" :aria-controls="'flush-collapseTwo'">Creators</button>
                  </h2>
                  <div class="accordion-collapse collapse show" :id="'flush-collapseTwo'" :aria-labelledby="'flush-headingTwo'">
                    <div class="accordion-body"  v-if="resource.creatorsWithId">
                      <template>
                        <div class="listitem" v-for="collaborator in resource.creatorsWithId" :key="collaborator.name">
                        <h3> 
                          <router-link
                            :to="{
                              name: 'organizationView',
                              params: { id: collaborator.id },
                            }"
                          >
                            <span
                              style="overflow-wrap: break-word"
                              v-if="collaborator.name"
                            >
                              {{ collaborator.name }}
                            </span>
                          
                          </router-link>
                        </h3>
                          <span class="info" v-if="collaborator.type"> {{ Array.isArray(collaborator.type) && collaborator.type.length>0 ? collaborator.type[0]:  collaborator.type }} </span>
                      </div>
                      </template>
                      </div>
                      <div class="accordion-body"  v-if="resource.creators.length>0">
                      <template>
                        <div class="listitem" v-for="creator in resource.creators" :key="creator.name">
                        <h3> 
                          <span v-if="creator.name">
                              {{ creator.name }}</span>
                          <span v-else-if="creator.type">
                              {{ creator.type }}</span>
                        </h3>
                        <span class="info" v-if="creator.name && creator.type"> {{ creator.type }} </span>
                      </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="accordion-item" v-if="resource.areasOfFocus && resource.areasOfFocus.length>0">
                  <h2 class="accordion-header" id="flush-headingThree">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#flush-collapseThree'" aria-expanded="false" :aria-controls="'flush-collapseThree'">Areas Of Focus</button>
                  </h2>
                  <div class="accordion-collapse collapse" :id="'flush-collapseThree'" :aria-labelledby="'flush-headingThree'">
                    <div class="accordion-body">
                      <template>
                      <div class="listitem" v-bind:key="topic" v-for="topic in resource.areasOfFocus">
                        <h3> 
                          {{ topic }}
                        </h3>
                       
                      </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="accordion-item"  v-if="false">
                  <h2 class="accordion-header" id="flush-headingFour">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#flush-collapseFour'" aria-expanded="false" :aria-controls="'flush-collapseFour'">Notes</button>
                  </h2>
                  <div class="accordion-collapse collapse" :id="'flush-collapseFour'" :aria-labelledby="'flush-headingFour'">
                    <div class="accordion-body">
                      <p style="overflow-wrap: break-word">{{ resource.notes }}</p>
                    </div>
                  </div>
                </div>
              </div>
              
                <!-- rating-->
              <div class="raterecipe" v-if="authenticatedUser && this.$store.state.user.login !== this.resource.creator.login"> 
                <!-- heading-->
                <div v-if="!this.ratingSubmitted">
                  <div class="heading">
                  <h2>{{
                      initialRating === ""
                        ? "Rate this ingredient:"
                        : "Your rating:"
                    }}</h2>
                  <ul class="stars">
                   <v-app>
                      <v-rating
                      v-model="userRating"
                      background-color="orange lighten-3"
                      color="orange"
                      medium
                      hover
                    ></v-rating>
                  </v-app>
                  </ul>
                </div>
                <div
                class="content"
              >
                <b-form-textarea
                  v-model="userRatingComment"
                  placeholder="Say something about this ingredient"
                ></b-form-textarea>
                <b-button
                  @click="submitRating"
                  class="btn" type="button"
                >
                  {{ initialRating === "" ? "Submit " : "Edit your " }}rating
                </b-button>
              </div>
              </div>
                
               <div
                v-if="this.ratingSubmitted"
                class="content"
              >  
              <p
                class="text-left mt-1 pl-3"
                style="color: green"
              >
                Submitted!
              </p>
              </div>
              
              </div>
              </div>
              
            </div>
      </div>
      </div>
  </div>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
  </main>
</template>

<script>
import Keywords from "../components/Keywords";
import NoAccess from "../components/NoAccess";
import Autocomplete from "./Autocomplete";
import Rating from "../components/Rating";
import { mapGetters } from "vuex";
import { eventBus } from "../main";
import axios from "axios";
import { Disqus } from "vue-disqus";

export default {
  name: "resourceView",
  components: {
    Rating,
    Keywords,
    Autocomplete,
    NoAccess,
    Disqus,
  },
  data() {
    return {
      resource: {
        creator: "",
        creatorsWithId: [],
        rights: "",
        resourceType: [],
      },
      ratingSubmitted: false,
      ratings: "",
      ratingCommentsSectionShow: true,
      userRating: "",
      userRatingComment: "",
      initialRating: "",
      imageResourceUrl: null,
      emptyLoginAlert: false,
      emptyGroupNameAlert: false,
      emptyRightAlert: false,
      notFoundUserAlert: false,
      notFoundGroupAlert: false,
      sendChosenLogin1: "sendChosenLogin",

      selected: "a",
      GroupChosen: "",
      GroupChosenId: "",

      title: "",
      userLogin: null,
      userID: 0,
      right: null,
      users: "",
      Rights: [
        { text: "I will grant the right to ...", value: null },
        { text: "View the ingredient", value: "READ" },
        { text: "Edit the ingredient (the user will also have the right to further share the ingredient)", value: "WRITE" },
      ],
      value1: "",

      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
      },
      bookmarked: "",
    };
  },
  watch: {
    $route(to, from) {
      if (from.params.id && to.params.id) {
        this.$router.go(to);
      }
    },
  },
  created: function () {
    // get the resource
    this.getResource(this.$route.params.id);
    eventBus.$on("sendChosenLogin", (value11) => {
      this.value1 = value11;
    });
    this.getUserRating(this.$route.params.id);
    this.getRatings();
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    showPagination: function () {
      // display or not the pagination bar
      return this.pagination.totalCount > this.pagination.pageSize;
    },
    averageRating() {
      let rating = this.resource.avgRatingx100;
      if (rating < 50) return 0;
      else if (rating >= 50 && rating < 100) return 0.5;
      else if (rating >= 100 && rating < 150) return 1;
      else if (rating >= 150 && rating < 200) return 1.5;
      else if (rating >= 200 && rating < 250) return 2;
      else if (rating >= 250 && rating < 300) return 2.5;
      else if (rating >= 300 && rating < 350) return 3;
      else if (rating >= 350 && rating < 400) return 3.5;
      else if (rating >= 400 && rating < 450) return 4;
      else if (rating >= 450 && rating < 500) return 4.5;
      else if (rating === 500) return 5;
    },
    averageRatingStars() {
      if (this.resource.avgRatingx100 === -1) return "-";
      else return Math.max(0, this.resource.avgRatingx100 / 100);
    },
    isShared() {
      // check if the resource is shared
      return this.resource.isShared;
    },
    isEditable() {
      // check if edit action is allowed
      return this.resource.rights === "OWN" || this.resource.rights === "WRITE";
    },
    isDeletable() {
      // check if delete action is allowed
      // return !this.isShared
      return this.resource.rights === "OWN";
    },
    isShareable() {
      // check if share action is allowed
      return this.isEditable;
    },
    visibility() {
      return this.resource.publicReadable === true ? "Public" : "Private";
    },
    isImplemented() {
      if (this.resource.implemented) {
        return "check-circle";
      } else {
        return "times-circle";
      }
    },
    hideBanner2() {
      // Hide the division that displays the collaborators, areasOfFocus and targetGroup only
      // and if only these are not defined
      return !(
        this.resource.creatorsWithId &&
        this.resource.areasOfFocus &&
        this.resource.targetGroup
      );
    },
    hideBanner3() {
      // Hide the division that displays the collaborators, areasOfFocus and targetGroup only
      // and if only these are not defined
      return !(
        this.resource.ingredients &&
        this.resource.steps &&
        this.resource.challenges
      );
    },
  },
  methods: {
    getResourceType() {
      if (
        this.resource.resourceType.length > 1 &&
        this.resource.resourceType.includes("Other")
      ) {
        let index = this.resource.resourceType.indexOf("Other");
        this.resource.resourceType.splice(index, 1);
      }
      return this.resource.resourceType.join(", ");
    },
    getResourceLanguage() {
      if (this.resource.contentLanguage.includes("Other")) {
        if (
          this.resource.contentLanguage[
            this.resource.contentLanguage.length - 1
          ] !== ""
        ) {
          // If 'Other' is selected and the next value is not empty (deleted)
          let index = this.resource.contentLanguage.indexOf("Other");
          this.resource.contentLanguage.splice(index, 1);
          return this.resource.contentLanguage.join(", ");
        } else {
          return this.resource.contentLanguage[0];
        }
      }
      return this.resource.contentLanguage.join(", ");
    },
    getResourceLicense() {
      if (
        this.resource.license.includes("Other") &&
        this.resource.license.length > 1
      ) {
        let index = this.resource.license.indexOf("Other");
        this.resource.license.splice(index, 1);
      }
      return this.resource.license.join(", ");
    },
    ShareThisResource() {
      this.$bvModal.show("modal-prevent-closing");
    },
    hideModal() {
      //   this.recipeID = 0
      this.value1 = "";
      this.selected = "a";
      this.right = null;
      this.notFoundUserAlert = false;
      this.notFoundGroupAlert = false;
      this.emptyRightAlert = false;
      this.emptyLoginAlert = false;
      this.emptyGroupNameAlert = false;
      this.GroupChosen = "";
    },
    handleSubmit() {
      if (this.selected === "b") {
        this.emptyRightAlert = false;
        this.emptyGroupNameAlert = false;
        this.notFoundGroupAlert = false;

        // Exit when the form isn't valid
        if (this.GroupChosen === null || this.GroupChosen === "") {
          this.emptyGroupNameAlert = true;
        } else if (this.GroupChosen !== null && this.GroupChosen !== "") {
          this.emptyGroupNameAlert = false;

          axios
            .get("/group/byName?name=" + this.GroupChosen, {
              withCredentials: true,
            })
            .then((response) => {
              this.GroupChosenId = response.data.id;
              this.notFoundGroupAlert = false;
              if (this.right === "" || this.right === null) {
                this.emptyRightAlert = true;
              } else {
                this.SendUserDataToAPI();
              }
            })
            .catch((err) => {
              console.log(err);
              this.emptyGroupNameAlert = false;
              this.notFoundGroupAlert = true;
              this.userID = "";
            });
        }
      }

      if (this.selected === "a") {
        this.emptyRightAlert = false;
        this.emptyLoginAlert = false;
        this.notFoundUserAlert = false;

        // Exit when the form isn't valid
        if (this.value1 === null || this.value1 === "") {
          this.emptyLoginAlert = true;
          this.value1 = "";
        } else if (this.value1 !== null && this.value1 !== "") {
          this.emptyLoginAlert = false;
          axios
            .get(
              "/user/byLogin?login=" + this.value1,

              { withCredentials: true }
            )
            .then((response) => {
              this.userID = response.data.id;
              this.notFoundUserAlert = false;

              if (this.right === "" || this.right === null) {
                this.emptyRightAlert = true;
              } else {
                this.SendUserDataToAPI();
              }
            })
            .catch((err) => {
              console.log(err);
              this.emptyLoginAlert = false;
              this.notFoundUserAlert = true;
              this.userID = "";
            });
        }
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    SendUserDataToAPI() {
      if (this.selected === "a") {
        axios
          .post(
            "/share/Resource/" +
              this.$route.params.id +
              "?userId=" +
              this.userID +
              "&right=" +
              this.right,
            null,

            { withCredentials: true }
          )
          .then((response) => {
            console.log(response);
            this.recipeID = 0;
            this.value1 = "";
            this.right = null;
            this.notFoundUserAlert = false;
            this.emptyRightAlert = false;
            this.emptyLoginAlert = false;
            this.$bvModal.hide("modal-prevent-closing");
            this.$bvModal.show("modal-1");
          });
      }

      if (this.selected === "b") {
        axios
          .post(
            "/share/Resource/" +
              this.$route.params.id +
              "?groupId=" +
              this.GroupChosenId +
              "&right=" +
              this.right,
            null,

            { withCredentials: true }
          )
          .then((response) => {
            this.recipeID = 0;
            this.GroupChosenId = "";
            this.value1 = "";
            this.right = null;
            this.notFoundUserAlert = false;
            this.emptyRightAlert = false;
            this.emptyLoginAlert = false;
            this.$bvModal.hide("modal-prevent-closing");
            this.$bvModal.show("modal-2");
          });
      }
    },
    getResourceLink() {
      let link = this.resource.url;
      if (link && (link.startsWith("http") || link.startsWith("www"))) {
        return link;
      }
      return "#";
    },
    scrollTo(refName) {
      let element = this.$refs[refName];
      let top = element.offsetTop;
      window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth",
      });
    },
    initRatings() {
      this.ratings = [];
    },
    getRatings() {
      this.ratingCommentsSectionShow = true;
      let params = {
        id: this.$route.params.id,
        start: this.pagination.pageSize * (this.pagination.currentPage - 1),
        count: this.pagination.pageSize,
      };
      // get data
      let tempResources = [];
      this.$store.dispatch("getResourceCurrentRatings", params).then((data) => {
        tempResources = data;
        this.pagination.totalCount = data.length;
        this.initRatings();
        // adjust rating entities
        tempResources.forEach((rating) => {
          let temp = rating;
          this.ratings.push(temp);
        });
        console.log(this.ratings);
      });
    },
    hideRatingSubmitted() {
      this.ratingSubmitted = false;
    },
    updateAverageRating() {
      this.getResource(this.resource.id);
    },
    submitRating() {
      let ratingObj = {
        recipeId: this.$route.params.id,
        stars: this.userRating,
        comment: this.userRatingComment,
      };
      if (this.initialRating === "") {
        this.$store
          .dispatch("submitResourceRating", ratingObj)
          .then((response) => {
            this.ratingSubmitted = true;
            this.initialRating = this.userRating;
            setTimeout(this.hideRatingSubmitted, 500);
            this.getRatings();
            this.updateAverageRating();
            console.log(response);
          })
          .catch((error) => {
            console.info(error);
          });
      } else {
        this.$store
          .dispatch("deleteResourceRating", this.$route.params.id)
          .then((response) => {
            this.$store
              .dispatch("submitResourceRating", ratingObj)
              .then((response) => {
                this.ratingSubmitted = true;
                this.initialRating = this.userRating;
                setTimeout(this.hideRatingSubmitted, 500);
                this.getRatings();
                this.updateAverageRating();
                console.log(response);
              })
              .catch((error) => {
                console.info(error);
              });
          });
      }
    },
    getResource: function (resourceId) {
      // Fetch the resource and the resource
      this.$store.dispatch("getResourceEntity", resourceId).then((entity) => {
        this.resource = entity;
        this.resource.isShared = false;
        this.$set(this.resource, 'bookmarked', ( entity.bookmarked || false ))
      });
    },
    handleBookmarkResource(resource) {
      if (!resource.bookmarked) {
        this.$store
          .dispatch("bookmarkResource", resource.id)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              resource.bookmarked = true;
            }
          });
      } else {
        this.$store
          .dispatch("deleteBookmarkResource", resource.id)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              resource.bookmarked = false;
            }
          });
      }
    },
    getUserRating(id) {
      let ratingInfo = {
        resourceId: id,
        userId: this.$store.state.user.id,
      };
      this.$store
        .dispatch("getResourceRatingUser", ratingInfo)
        .then((response) => {
          if(response.length>0){
          this.userRating = response[0].stars;
          this.userRatingComment = response[0].comment;
          this.initialRating = this.userRating;}
        });
    },
    showMsgDelete(resId, resTitle) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete this resource.",
          {
            title: "Are you sure you want to delete " + resTitle + "?",
            size: "bg",
            buttonSize: "bg",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          this.boxTwo = value;
          if (this.boxTwo) {
            this.deleteResource(resId);
          } else {
          }
        })
        .catch((error) => {
          alert("An error occurred! Please refresh the page." + error);
        });
    },
    deleteResource(resourceId) {
      // Delete the resource and direct user's browser in resources list
      this.$store.dispatch("deleteResourceEntity", resourceId).then((data) => {
        this.$router.push({ name: "resources" });
      });
    },
    adjustIcon(mediaType) {
      // load the proper icon given the media type
      if (mediaType === "Image") {
        return "image";
      } else if (mediaType === "Audio") {
        return "file-audio";
      } else if (mediaType === "Linked Video") {
        return "play-circle";
      } else if (mediaType === "Website") {
        return "link";
      } else if (mediaType === "Text") {
        return "file-alt";
      } else if (mediaType === "Pdf") {
        return "file-pdf";
      } else {
        return "file-alt";
      }
    },
    adjustColor(mediaType) {
      // load the proper icon given the media type
      if (mediaType === "Image") {
        return "image";
      } else if (mediaType === "Audio") {
        return "color: #f0d6f1";
      } else if (mediaType === "Linked Video") {
        return "color: #ff6c6c";
      } else if (mediaType === "Website") {
        return "color: #95c9ff";
      } else if (mediaType === "Text") {
        return "color: #fff37a";
      } else if (mediaType === "Pdf") {
        return "color: red";
      } else {
        return "color: #fff37a";
      }
    },
    existKeywords() {
      return Object.keys(this.resource.keywords).length > 0;
    },
  },
  filters: {},
};
</script>

<style scoped>
.views {
  margin-bottom:4em;
}
.border-custom-lgr {
  border: 1px solid #d3d3d366;
}

#description-container {
  min-height: 80px !important;
}

.min-h-250 {
  min-height: 250px !important;
}

.col-container {
  border-left: 1px solid #d3d3d366;
  border-top: 1px solid #d3d3d366;
  border-bottom: 1px solid #d3d3d366;
  border-right: 10px solid #f7f7f7;
}

#image-container {
  min-height: 250px !important;
}

</style>



// WEBPACK FOOTER //
// src/views/ResourceView.vue